module.exports = __webpack_public_path__ + "static/media/Madfit_Website_10.a258c130.jpg";